import './moment.js';
import DA_DK from './language-maps/da.js';
import EN_US from './language-maps/en.js';
import NL from './language-maps/nl.js';
import NO from './language-maps/no.js';
import SV from './language-maps/sv.js';
import { Lang } from './Lang.js';
const langMap = {
    en: Lang.en,
    da: Lang.da,
    no: Lang.no,
    sv: Lang.sv,
    nl: Lang.nl,
};
const langs = {
    [Lang.en]: EN_US,
    [Lang.da]: DA_DK,
    [Lang.no]: NO,
    [Lang.sv]: SV,
    [Lang.nl]: NL,
};
const langTranslator = (lang) => {
    return langMap[`${lang}`.toLowerCase().slice(0, 2)] || Lang.en;
};
export const get = (lang) => {
    const l = langTranslator(lang);
    const en = EN_US;
    if (langs[l] == null) {
        return en;
    }
    return Object.assign({}, en, langs[l]);
};
//# sourceMappingURL=index.js.map